"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageView = void 0;
const react_1 = __importDefault(require("react"));
require("./ImageView.scss");
const package_1 = require("../package");
const ImageObject_1 = require("../shapes/ImageObject");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
exports.ImageView = (0, package_1.linkedComponent)(ImageObject_1.ImageObject.request((imageObject) => [imageObject.contentUrl]), ({ linkedData, width, height }) => {
    let [contentUrl] = linkedData;
    return react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)(contentUrl), width: width, height: height });
});
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=ImageView.js.map